import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import moment from 'moment';
import Breadcrumbs from '../../common/Breadcrumbs';
import Table from '../../сomponents/Table';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import { clearTasks } from '../../actions/dashboard';
import { fetchAllTasks, deleteWOById } from '../../api/dashboard';
import Preloader from '../../common/Preloader';
import hasAccess from "../../helpers/permissionChecker";

export class WorkOrders extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.addWorkOrder = this.addWorkOrder.bind(this);
    this.getWorkOrders = this.getWorkOrders.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      currentPage: 0,
    };

    this.columns = [
      'task_name',
      'customer',
      'description',
      'project_name',
      'status',
      'task_created',
      'due_date',
    ];

    this.columnNames = [
      'Work order',
      'Customer',
      'Description',
      'Project',
      'Status',
      'Date created',
      'Due date',
    ];

    this.sortable = [
      'task_name',
      'customer',
      'description',
      'project_name',
      'status',
      {
        column: 'task_created',
        sortFunction: (a, b) => (a ? new Date(a).getTime() : '') < (b ? new Date(b).getTime() : '') ? -1 : 1
      },
      {
        column: 'due_date',
        sortFunction: (a, b) => (a ? new Date(a).getTime() : '') < (b ? new Date(b).getTime() : '') ? -1 : 1
      },
    ];
  
  }

  addWorkOrder() {
    this.props.moveToAdd();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  componentDidMount() {
    this.props.loadList();
  }

  componentDidUpdate(prevProps) {
    const prevLocation = path(['router', 'location', 'key'], prevProps);
    const currentLocation = path(['router', 'location', 'key'], this.props);
    if (prevLocation !== currentLocation) {
      this.props.loadList();
    }
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      redirect: '/pages/work-orders',
      handler: deleteWOById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteWOById',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  getStatus(status) {
    const statuses = {
      'new': 'New',
      'hold': 'Hold',
      'in_progress': 'In Progress',
      'hot': 'HOT',
      're_work': 'Re-work',
      'ready': 'Ready',
      'closed': 'Closed',
    };
  
    return statuses[status] || status;
  }

  prepareTableData(items, extraFieldToShow) {
    const dueDateFieldMeta = extraFieldToShow.find((item) => item.label === 'Due date');
    const dueDateField = dueDateFieldMeta ? `extra_${dueDateFieldMeta.id}` : null;

    return items.map((item) => ({
      key: item.task_id,
      id: item.task_id,
      user_id: item.user_id,
      task_name: item.task_name,
      customer: item.customer,
      project_name: item.project_name,
      status: this.getStatus(item.status),
      task_created: item.task_created ? moment(item.task_created).format('M/D/YYYY') : '',
      due_date: dueDateField && item[dueDateField] ? moment(item[dueDateField]).format('M/D/YYYY') : '',
      description: item.description
    }));
  }

  getWorkOrders() {
    const workOrdersList = path(['dashboard', 'tasks'], this.props);
    const extraFieldToShow = path(['dashboard', 'extra_field_to_show'], this.props) || [];

    if (!workOrdersList) {
      return null;
    }

    const itemActions = {
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        permission: { 'permAreaKey': 'workOrder', 'permTypeKey': 'edit' },
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        authorColumnName: 'user_id',
        permission: { 'permAreaKey': 'workOrder', 'permTypeKey': 'delete' },
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    return (
      <Table
        items={this.prepareTableData(workOrdersList, extraFieldToShow)}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        actions={itemActions}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
        sortable={this.sortable}
      />
    );
  }

  render() {
    const workOrders = this.getWorkOrders();
    let preloader = null;

    if (workOrders === null) {
      preloader = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'style', name: 'Work orders' },
        ]} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            Work orders
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'workOrder', 'permTypeKey': 'create' }) &&
              <div className="clearfix mb-3">
                <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addWorkOrder}>
                  <i className="material-icons">add_circle_outline</i>
                  <span className="color-default">Add</span>
                </button>
              </div>
            }
            {preloader}
            {workOrders}
            <ConfirmAction id={'deleteWOById'} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadList: () => {
      fetchAllTasks()(dispatch);
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/task/' + id));
    },
    moveToAdd: () => {
      dispatch(push('/pages/work-order'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
    clearData: () => {
      dispatch(clearTasks());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrders);



// WEBPACK FOOTER //
// ./src/containers/WorkOrders/index.js